import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import {
  DEFAULT_ONBOARDING_DATA,
  DEFAULT_ONBOARDING_DONE,
} from '@/features/onboarding/constants/onboardingData';
import {
  type DefaultOnboardingData,
  ONBOARDING_STEPS,
  type OnboardingData,
  type OnboardingDoneMap,
  type OnboardingStep,
} from '@/features/onboarding/types/onboardingData';

export const ONBOARDING_DATA_STORAGE_KEY = 'onboarding:data:v2';
export const ONBOARDING_DONE_STORAGE_KEY = 'onboarding:done:v2';

export const onboardingDataAtom = atomWithStorage<DefaultOnboardingData>(
  ONBOARDING_DATA_STORAGE_KEY,
  DEFAULT_ONBOARDING_DATA,
  undefined,
  {
    getOnInit: true,
  },
);

export const onboardingDoneAtom = atomWithStorage<OnboardingDoneMap>(
  ONBOARDING_DONE_STORAGE_KEY,
  DEFAULT_ONBOARDING_DONE,
  undefined,
  {
    getOnInit: true,
  },
);

export const setStepDataAtom = atom(
  null,
  (
    get,
    set,
    payload: {
      step: OnboardingStep;
      data: OnboardingData[typeof payload.step];
    },
  ) => {
    const prev = get(onboardingDataAtom);

    set(onboardingDataAtom, {
      ...prev,
      [payload.step]: payload.data,
    });
  },
);

export const setStepDoneAtom = atom(
  null,
  (
    get,
    set,
    payload: {
      step: OnboardingStep;
      value: boolean;
    },
  ) => {
    const { step, value } = payload;
    const prev = get(onboardingDoneAtom);
    set(onboardingDoneAtom, { ...prev, [step]: value });
  },
);

export const lastAllowedStepAtom = atom<OnboardingStep>(get => {
  const done = get(onboardingDoneAtom);
  for (const step of ONBOARDING_STEPS) {
    if (!done[step]) return step;
  }
  return ONBOARDING_STEPS[ONBOARDING_STEPS.length - 1];
});
